import ButtonWithSpinnerModule from 'StandaloneComponents/button_with_spinner_module'

angular.module('bzReviewsModule', [ButtonWithSpinnerModule])
